import { Extension as f } from "../../node_modules/@tiptap/core/dist/index.mjs";
import { TextSelection as l, AllSelection as c } from "../../node_modules/prosemirror-state/dist/index.mjs";
function m(e, t, i) {
  return e < t ? t : e > i ? i : e;
}
var p = /* @__PURE__ */ ((e) => (e[e.min = 0] = "min", e[e.max = 140] = "max", e[e.more = 20] = "more", e[e.less = -20] = "less", e))(p || {});
function y(e) {
  return e.type.name === "bullet_list";
}
function g(e) {
  return e.type.name === "order_list";
}
function L(e) {
  return y(e) || g(e);
}
function h(e, t, i) {
  if (!e.doc) return e;
  const n = e.doc.nodeAt(t);
  if (!n) return e;
  const d = 0, a = 140;
  let r = 0;
  typeof n.attrs.indent == "number" ? r = n.attrs.indent : typeof n.attrs.indent == "string" && (r = parseInt(n.attrs.indent) || 0);
  const s = m(r + i, d, a);
  if (s === r) return e;
  const o = {
    ...n.attrs,
    indent: s
  };
  return e.setNodeMarkup(t, n.type, o, n.marks);
}
function u(e, t) {
  const { doc: i, selection: n } = e;
  if (!i || !n || !(n instanceof l || n instanceof c))
    return e;
  const { from: d, to: a } = n;
  return i.nodesBetween(d, a, (r, s) => {
    const o = r.type;
    return o.name === "paragraph" || o.name === "heading" ? (e = h(e, s, t), !1) : !L(r);
  }), e;
}
const I = f.create({
  name: "indent",
  addOptions() {
    return {
      types: ["heading", "paragraph"],
      indentLevels: [0, 20, 40, 60, 80, 100, 120, 140],
      defaultIndentLevel: 0
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          indent: {
            default: this.options.defaultIndentLevel,
            renderHTML: (e) => ({
              style: `margin-left: ${typeof e.indent == "number" ? e.indent : parseInt(String(e.indent)) || this.options.defaultIndentLevel}px;`
            }),
            parseHTML: (e) => {
              const t = e.style.marginLeft;
              let i = this.options.defaultIndentLevel;
              if (t && typeof t == "string") {
                const n = parseInt(t.replace(/[^\d.-]/g, ""));
                isNaN(n) || (i = n);
              }
              return i;
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      indent: () => ({ tr: e, state: t, dispatch: i }) => {
        const { selection: n } = t;
        return e = e.setSelection(n), e = u(
          e,
          20
          /* more */
        ), e.docChanged ? (i && i(e), !0) : !1;
      },
      outdent: () => ({ tr: e, state: t, dispatch: i }) => {
        const { selection: n } = t;
        return e = e.setSelection(n), e = u(
          e,
          -20
          /* less */
        ), e.docChanged ? (i && i(e), !0) : !1;
      }
    };
  }
});
export {
  I as Indent,
  p as IndentProps,
  m as clamp,
  y as isBulletListNode,
  L as isListNode,
  g as isOrderedListNode
};
